import {createReducer} from '@reduxjs/toolkit'
import {TicketWithFormattedSalePeriod} from '@wix/wix-events-commons-statics'

const defaultState: TicketWithFormattedSalePeriod[] = []

export const demoTickets = createReducer(defaultState, _ => {})
